// Base de datos de síntomas SNOMED
export const mockSnomed = [
  { id: "29857009", code: "29857009", term: "Dolor torácico" },
  { id: "267036007", code: "267036007", term: "Dificultad para respirar" },
  { id: "422587007", code: "422587007", term: "Náuseas" },
  { id: "415690000", code: "415690000", term: "Sudoración" },
  { id: "84229001", code: "84229001", term: "Fatiga" },
  { id: "102616008", code: "102616008", term: "Dolor irradiado al brazo izquierdo" },
  { id: "3006004", code: "3006004", term: "Sensación de opresión" },
  { id: "80313002", code: "80313002", term: "Palpitaciones" },
  { id: "48694002", code: "48694002", term: "Ansiedad" },
  { id: "399153001", code: "399153001", term: "Mareo" },
  { id: "25064002", code: "25064002", term: "Cefalea pulsátil" },
  { id: "246656007", code: "246656007", term: "Fotofobia" },
  { id: "126271002", code: "126271002", term: "Vómitos" },
  { id: "279083003", code: "279083003", term: "Dolor unilateral" },
  { id: "162397003", code: "162397003", term: "Dolor de garganta" },
  { id: "386661006", code: "386661006", term: "Fiebre" },
  { id: "68962001", code: "68962001", term: "Tos" },
  { id: "21522001", code: "21522001", term: "Dolor abdominal" },
  { id: "62315008", code: "62315008", term: "Diarrea" },
  { id: "271757001", code: "271757001", term: "Acidez estomacal" }
];

// Base de datos de diagnósticos con sus síntomas asociados
export const diagnosisDatabase = [
  {
    id: "1",
    term: "Síndrome Coronario Agudo",
    code: "394659003",
    baseProbability: 20,
    severity: "alta",
    specialty: ["Cardiología", "Medicina de Emergencia"],
    description: "Espectro de condiciones que resultan de un suministro insuficiente de sangre al corazón.",
    bodySystem: "Cardiovascular",
    prevalence: "común",
    associatedSymptoms: [
      { symptomTerm: "Dolor torácico", weight: 40, requiredSeverity: ["moderate", "severe"] },
      { symptomTerm: "Dificultad para respirar", weight: 25, requiredSeverity: ["mild", "moderate", "severe"] },
      { symptomTerm: "Dolor irradiado al brazo izquierdo", weight: 30, requiredSeverity: ["mild", "moderate", "severe"] },
      { symptomTerm: "Náuseas", weight: 15, requiredSeverity: ["mild", "moderate", "severe"] },
      { symptomTerm: "Sudoración", weight: 20, requiredSeverity: ["mild", "moderate", "severe"] },
      { symptomTerm: "Sensación de opresión", weight: 25, requiredSeverity: ["moderate", "severe"] }
    ]
  },
  {
    id: "2",
    term: "Angina Inestable",
    code: "25106000",
    baseProbability: 15,
    severity: "alta",
    specialty: ["Cardiología"],
    description: "Forma inestable de angina de pecho que ocurre en reposo o con esfuerzo mínimo.",
    bodySystem: "Cardiovascular",
    prevalence: "común",
    associatedSymptoms: [
      { symptomTerm: "Dolor torácico", weight: 45, requiredSeverity: ["moderate", "severe"] },
      { symptomTerm: "Dificultad para respirar", weight: 20, requiredSeverity: ["mild", "moderate"] },
      { symptomTerm: "Fatiga", weight: 15, requiredSeverity: ["mild", "moderate", "severe"] },
      { symptomTerm: "Ansiedad", weight: 10, requiredSeverity: ["mild", "moderate", "severe"] }
    ]
  },
  {
    id: "3",
    term: "Pericarditis Aguda",
    code: "3238004",
    baseProbability: 10,
    severity: "media",
    specialty: ["Cardiología"],
    description: "Inflamación del pericardio, la membrana que rodea el corazón.",
    bodySystem: "Cardiovascular",
    prevalence: "poco común",
    associatedSymptoms: [
      { symptomTerm: "Dolor torácico", weight: 50, requiredSeverity: ["mild", "moderate", "severe"] },
      { symptomTerm: "Fiebre", weight: 25, requiredSeverity: ["mild", "moderate", "severe"] },
      { symptomTerm: "Fatiga", weight: 15, requiredSeverity: ["mild", "moderate"] }
    ]
  },
  {
    id: "4",
    term: "Neumonía",
    code: "233604007",
    baseProbability: 12,
    severity: "media",
    specialty: ["Neumología", "Medicina General"],
    description: "Infección que inflama los sacos aéreos de uno o ambos pulmones.",
    bodySystem: "Respiratorio",
    prevalence: "común",
    associatedSymptoms: [
      { symptomTerm: "Dificultad para respirar", weight: 35, requiredSeverity: ["moderate", "severe"] },
      { symptomTerm: "Fiebre", weight: 30, requiredSeverity: ["moderate", "severe"] },
      { symptomTerm: "Tos", weight: 25, requiredSeverity: ["mild", "moderate", "severe"] },
      { symptomTerm: "Fatiga", weight: 20, requiredSeverity: ["mild", "moderate", "severe"] },
      { symptomTerm: "Dolor torácico", weight: 15, requiredSeverity: ["mild", "moderate"] }
    ]
  },
  {
    id: "5",
    term: "Reflujo Gastroesofágico",
    code: "235595009",
    baseProbability: 8,
    severity: "baja",
    specialty: ["Gastroenterología"],
    description: "Condición en la que los contenidos estomacales fluyen hacia el esófago.",
    bodySystem: "Digestivo",
    prevalence: "muy común",
    associatedSymptoms: [
      { symptomTerm: "Acidez estomacal", weight: 40, requiredSeverity: ["mild", "moderate", "severe"] },
      { symptomTerm: "Náuseas", weight: 25, requiredSeverity: ["mild", "moderate"] },
      { symptomTerm: "Dolor torácico", weight: 20, requiredSeverity: ["mild"] },
      { symptomTerm: "Dolor abdominal", weight: 15, requiredSeverity: ["mild", "moderate"] }
    ]
  },
  {
    id: "6",
    term: "Migraña",
    code: "37796009",
    baseProbability: 10,
    severity: "media",
    specialty: ["Neurología"],
    description: "Tipo de dolor de cabeza que puede causar dolor severo y otros síntomas.",
    bodySystem: "Neurológico",
    prevalence: "común",
    associatedSymptoms: [
      { symptomTerm: "Cefalea pulsátil", weight: 50, requiredSeverity: ["moderate", "severe"] },
      { symptomTerm: "Fotofobia", weight: 30, requiredSeverity: ["mild", "moderate", "severe"] },
      { symptomTerm: "Náuseas", weight: 25, requiredSeverity: ["mild", "moderate"] },
      { symptomTerm: "Vómitos", weight: 20, requiredSeverity: ["mild", "moderate"] },
      { symptomTerm: "Dolor unilateral", weight: 25, requiredSeverity: ["moderate", "severe"] }
    ]
  },
  {
    id: "7",
    term: "Gastroenteritis",
    code: "25374005",
    baseProbability: 8,
    severity: "baja",
    specialty: ["Gastroenterología", "Medicina General"],
    description: "Inflamación del estómago e intestinos que causa diarrea, vómitos y dolor abdominal.",
    bodySystem: "Digestivo",
    prevalence: "muy común",
    associatedSymptoms: [
      { symptomTerm: "Náuseas", weight: 30, requiredSeverity: ["moderate", "severe"] },
      { symptomTerm: "Vómitos", weight: 35, requiredSeverity: ["moderate", "severe"] },
      { symptomTerm: "Diarrea", weight: 40, requiredSeverity: ["moderate", "severe"] },
      { symptomTerm: "Dolor abdominal", weight: 25, requiredSeverity: ["mild", "moderate", "severe"] },
      { symptomTerm: "Fiebre", weight: 15, requiredSeverity: ["mild", "moderate"] }
    ]
  },
  {
    id: "8",
    term: "Faringitis",
    code: "405737000",
    baseProbability: 5,
    severity: "baja",
    specialty: ["Otorrinolaringología", "Medicina General"],
    description: "Inflamación de la faringe que causa dolor de garganta.",
    bodySystem: "Respiratorio",
    prevalence: "muy común",
    associatedSymptoms: [
      { symptomTerm: "Dolor de garganta", weight: 50, requiredSeverity: ["mild", "moderate", "severe"] },
      { symptomTerm: "Fiebre", weight: 20, requiredSeverity: ["mild", "moderate"] },
      { symptomTerm: "Fatiga", weight: 15, requiredSeverity: ["mild", "moderate"] }
    ]
  }
];

// Mock del historial del paciente
export const mockPatientHistory = [
  {
    consultationDate: '2025-03-15',
    symptoms: [
      { id: "29857009", code: "29857009", term: "Dolor torácico", severity: "mild", source: "previous" },
      { id: "267036007", code: "267036007", term: "Dificultad para respirar", severity: "moderate", source: "previous" }
    ]
  },
  {
    consultationDate: '2025-02-01',
    symptoms: [
      { id: "422587007", code: "422587007", term: "Náuseas", severity: "mild", source: "previous" },
      { id: "162397003", code: "162397003", term: "Dolor de garganta", severity: "moderate", source: "previous" },
      { id: "386661006", code: "386661006", term: "Fiebre", severity: "moderate", source: "previous" }
    ]
  }
];

// Mapeado de relaciones entre síntomas
export const relatedSymptomsMap = {
  "Dolor torácico": ["Dolor irradiado al brazo izquierdo", "Sensación de opresión", "Palpitaciones", "Ansiedad", "Mareo"],
  "Cefalea pulsátil": ["Fotofobia", "Náuseas", "Vómitos", "Dolor unilateral"],
  "Fiebre": ["Dolor de garganta", "Fatiga", "Dolor de cabeza"],
  "Náuseas": ["Vómitos", "Mareo", "Dolor abdominal"],
  "Dificultad para respirar": ["Dolor torácico", "Fatiga", "Ansiedad", "Palpitaciones"]
};

// Reglas de contradicción de síntomas
export const contradictionRules = [
  {
    symptoms: ["Dolor torácico", "Ausencia de dolor torácico"],
    message: "Contradicción: No puede haber presencia y ausencia de dolor torácico simultáneamente"
  },
  {
    symptoms: ["Fiebre", "Temperatura normal"],
    message: "Contradicción: No puede haber fiebre y temperatura normal simultáneamente"
  },
  {
    // Contradicción clínica: mareo severo sin presencia de otros síntomas cardiovasculares
    condition: (symptoms) => {
      const mareo = symptoms.find(s => s.term === "Mareo" && s.severity === "severe");
      const cardiovascularSymptoms = symptoms.filter(s => 
        ["Dolor torácico", "Palpitaciones", "Dificultad para respirar"].includes(s.term)
      );
      return mareo && cardiovascularSymptoms.length === 0;
    },
    message: "Advertencia clínica: Mareo severo sin otros síntomas cardiovasculares asociados"
  },
  {
    // Contradicción contextual: Dolor severo con estado general bueno
    condition: (symptoms) => {
      const severePain = symptoms.some(s => s.term.toLowerCase().includes("dolor") && s.severity === "severe");
      const goodGeneralState = symptoms.some(s => s.term === "Estado general bueno");
      return severePain && goodGeneralState;
    },
    message: "Posible inconsistencia: Dolor severo reportado con estado general bueno"
  }
];

// Mapeo de severidad
export const severityMap = {
  "mild": "Leve",
  "moderate": "Moderada", 
  "severe": "Severa",
  "present": "Presente"
};

// Mapeo de colores para badges
export const badgeColorMap = {
  "mild": "bg-success",
  "moderate": "bg-warning",
  "severe": "bg-danger",
  "present": "bg-info",
  "absent": "bg-secondary",
  "default": "bg-info"
};